/* eslint-disable */
import React from 'react';
import styles from './Option.css';

const debug = _debug('app:Option');

const Option = ({ focusedOption, focusOption, option,
                            selectValue, removeValue, valueArray, activeIndex, key, style }) => {
  let isSelected = false;
  const classNames = [styles.Option];
  if (option === focusedOption) {
    classNames.push(styles.OptionFocused);
  }
  if (valueArray && valueArray.map(e => e.value).indexOf(option.value) > -1) {
    classNames.push(styles.OptionSelected);
    isSelected = true;
  }
  if (option.value === 'Warm' && activeIndex === 0) {
    classNames.push(styles.OptionWarmRow);
  }

  if(option.disable){
    if (isSelected) {
      const newOmittedObj = _.omit(option, ['disable']);
      removeValue(newOmittedObj);
    }
    return(
      <div
        className={classNames.join(' ')}
        key={key}
        style={style}
      >
        <label htmlFor="label" className={styles.LabelDisabled}>
          {option.label}
        </label>
      </div>
      )
  }

  return (
    <div
      className={classNames.join(' ')}
      onClick={() => {
        if (isSelected) {
          const newOmittedObj = _.omit(option, ['disable']);
          removeValue(newOmittedObj);
        } else {
          selectValue(option);
        }
      }}
      onMouseOver={() => focusOption(option)}
      key={key}
      style={style}
    >
      <label htmlFor="label" className={styles.Label}>
        {option.label}
      </label>
      {isSelected &&
        <img
          alt="checkmark"
          className={styles.checkmark}
          src={'static/select_ico.png'}
        />
      }
    </div>
  );
};

Option.propTypes = {
  focusedOption: React.PropTypes.object,
  focusOption: React.PropTypes.func,
  option: React.PropTypes.object,
  selectValue: React.PropTypes.func,
  removeValue: React.PropTypes.func,
  valueArray: React.PropTypes.array,
  activeIndex: React.PropTypes.Number
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/Option/Option.js